
const getDynamicTitleByName = ({ dynamicHomePageSettings, name }) => {
    return dynamicHomePageSettings?.filter((item) => item?.name == name)
}

const getDynamicTitleByLocale = ({ dynamicHomePageSettings, locale, }) => {
    return dynamicHomePageSettings?.filter((item) => item?.language == locale)
}

export { getDynamicTitleByLocale, getDynamicTitleByName };